import React from "react";
import DropDown from "../../../features/dropDown/DropDown";
import classes from "./DiscoveryFilterBar.module.css";

const DiscoveryFilterDropDown = ({ filter, selectedId, lang, onSelectOption }) => {
    
    const selectedOpt = selectedId ? filter?.options?.find((o) => o.id === selectedId) : null;
    const displayValue = selectedOpt ? selectedOpt?.label?.[lang] : undefined;

    return (
        <DropDown
            value={displayValue}
            arrowColor="#010101ff"
            dropClass={classes.FilterDrop}
            dropClassDropDown={classes.FilterDropMenu}
            optionClassName={classes.FilterOption}
            options={filter?.options?.map((option) => ({
                key: `${filter.name}-${option.id}`,
                value: option?.label?.[lang],
                onClick: () => onSelectOption(option),
            }))}
        >
            {filter.label?.[lang] ?? filter.label?.he}
        </DropDown>
    );
};

export default DiscoveryFilterDropDown;
